import { render, staticRenderFns } from "./qChat.vue?vue&type=template&id=b6f17aa4&scoped=true&"
import script from "./qChat.vue?vue&type=script&lang=ts&"
export * from "./qChat.vue?vue&type=script&lang=ts&"
import style0 from "./qChat.vue?vue&type=style&index=0&id=b6f17aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f17aa4",
  null
  
)

export default component.exports